import React from 'react';
import { extractAriaProps } from './extract-aria-props';
/**
 * Utility hook to extract all aria-attributes that are added to components
 */
export const useAriaProps = (props) => {
    return React.useMemo(() => {
        return extractAriaProps(props);
    }, [props]);
};
